import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LmrServices } from '../../services/lmr.service';
import {
  DialogConfig,
  DialogImportComponent,
} from '../../components/dialog-import/dialog-import.component';
import Utils from '@app/shared/utils/utils';

export interface BidItem {
  model: string;
  partNumber: string;
  solution: string;
  [key: string]: any; // Para aceitar colunas dinâmicas de fornecedores
}

@Component({
  selector: 'app-bid',
  templateUrl: './bid.component.html',
  styleUrls: ['./bid.component.sass'],
})
export class BidComponent implements OnInit {
  baseColumns: string[] = ['model', 'partNumber', 'solution'];
  displayedColumns: string[] = [];
  selectedPartners: string[] = [];
  dynamicSuppliers: any[] = [];
  dataSource = new MatTableDataSource<BidItem>([]);

  filtros = {
    fornecedoresId: null as string[] | null,
    filtro: '',
    page: 1,
    pageSize: 10,
  };
  partners: any[] = [];
  searchTerm: string = '';
  totalCount = 0;
  loaded = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private dialog: MatDialog,
    private lmrService: LmrServices,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadData();
    this.loadPartners();
  }

  loadPartners() {
    this.lmrService.suppliersBid().subscribe(
      (res: any) => {
        this.partners = res;
      },
      (error) => this.toastr.error('Erro ao carregar lista de parceiros.')
    );
  }

  loadData() {
    this.lmrService.listBid(this.filtros).subscribe(
      (response: any) => {
        const { pecas, colunas } = response;

        this.dynamicSuppliers = colunas;
        this.displayedColumns = [...this.baseColumns, ...colunas.map((c: any) => c.fornecedorNome)];
        this.dataSource.data = pecas.page.map((peca: any) => {
          const item: BidItem = {
            model: peca.modeloResumido,
            partNumber: peca.partNumber,
            solution: peca.pecaSolucao,
          };

          peca.precosPorFornecedor.forEach((forn: any) => {
            item[forn.nome] = {
              peca: forn.valorPeca,
              mao: forn.valorMaoDeObra,
              total: forn.valorTotal,
            };
          });

          return item;
        });

        this.totalCount = pecas.count;
        this.loaded = true;
      },
      (error) => {
        this.loaded = true;
        this.toastr.error(error.errors.at(0) ?? 'Erro ao carregar dados do BID.');
      }
    );
  }

  onPartnerChange(event: any) {
    const value = event.value;
    this.filtros.fornecedoresId = value === 'all' ? null : [value];
    this.filtros.page = 1;
    this.loadData();
  }

  onSearchChange(value: string) {
    if (value === '') {
      this.applyFilters();
    }
  }

  applyFilters() {
    this.filtros.filtro = this.searchTerm.trim();
    this.filtros.fornecedoresId = this.selectedPartners.length > 0 ? this.selectedPartners : null;

    this.filtros.page = 1;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    this.loadData();
  }

  toggleAllSelection() {
    if (this.selectedPartners.length === this.partners.length) {
      this.selectedPartners = [];
    } else {
      this.selectedPartners = this.partners.map((p) => p.id);
    }
  }

  handlePageEvent(event: any) {
    this.filtros.page = event.pageIndex + 1;
    this.filtros.pageSize = event.pageSize;
    this.loadData();
  }

  openImportDialog() {
    const dialogRef = this.dialog.open(DialogImportComponent, {
      width: '900px',
      maxWidth: '95vw',
      height: '90%',
      panelClass: 'custom-import-dialog',
      data: {
        partners: this.partners,
        mode: 'full',
        textDialog:
          'Para importar a tabela, selecione o parceiro desejado para configuração dos valores e o arquivo base com as informações dos valores de cada peça, em seguida, clique em “Importar”.',
        importFn: (file: File, partnerId?: string) =>
          this.lmrService.importSupplier(file, partnerId!),
      } as DialogConfig,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadData();
    });
  }

  downloadTemplate() {
    const fileName = `Modelo_Template_Importacao_BID`;
    this.lmrService.exportTemplateImportBID().subscribe({
      next: (data) => {
        Utils.createAndDownloadBlobFile(data, fileName, 'xlsx');
      },
      error: (err) => {
        const { errors } = Utils.arrayBufferToJson(err);
        this.toastr.error(errors || 'Ocorreu um erro ao exportar, tente novamente mais tarde.');
      },
    });
  }

  exportComparativo() {
    console.log(this.filtros);
    this.lmrService.exportDataTable(this.filtros).subscribe({
      next: () => {
        this.toastr.success('Dados exportados com sucesso.');
      },
      error: (err) => {
        this.toastr.error(err || 'Ocorreu um erro ao exportar, tente novamente mais tarde.');
      },
    });
  }
}
